export default __webpack_public_path__ + "static/media/outlook.a2c6ec1b.png";